// src/features/orders/outSourceSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// OutSource type
export interface OutSource {
  id: string;
  [key: string]: any; // flexible, allow extra fields from API
}

// API response shape for list
interface OutSourceListResponse {
  outSources: OutSource[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface OutSourceState {
  data: OutSourceListResponse | null;
  loading: boolean;
  error: string | null;
}

// Payload for updating a outSource
export interface OutSourceUpdatePayload {
  id: string;
  [key: string]: any;
}

// ✅ Initial state
const initialState: OutSourceState = {
  data: null,
  loading: false,
  error: null,
};

// ✅ Slice
const outSourceSlice = createSlice({
  name: 'outSource',
  initialState,
  reducers: {
    // Set full outSource list response
    setOutSourceList(state, action: PayloadAction<OutSourceListResponse>) {
      state.data = action.payload;
      state.loading = false;
    },

    // Add a new outSource
    // addOutSource(state, action: PayloadAction<any>) {
    //   const details = action.payload;

    //   if (!details) return;

    //   const newOutSource: OutSource = {
    //     id: details.id,
    //     companyName: details.companyName || "",
    //     contactPersonName: details.contactPersonName || "",
    //     mobileNo: details.mobileNo || "",
    //     email: details.email || "",
    //     warehouseId: details.warehouseId || "",
    //     cityId: details.cityId || "",
    //     address: details.address || "",
    //     specialization: details.specialization || "",
    //     billingCycle: details.billingCycle || "",
    //     serviceAreaCoverage: details.serviceAreaCoverage || "",
    //     contractStartDate: details.contractStartDate || "",
    //     contractEndDate: details.contractEndDate || "",
    //     vatNumber: details.vatNumber || "",
    //     crNumber: details.crNumber || "",
    //     primaryContactName: details.primaryContactName || "",
    //     primaryContactNumber: details.primaryContactNumber || "",
    //     primaryEmailAddress: details.primaryEmailAddress || "",
    //     active: details.active ?? false,
    //     userId: details.userId || "",
    //     vatDoc: details.vatDoc || null,
    //     crDoc: details.crDoc || null,
    //     companyLogo: details.companyLogo || null,
    //     contractDoc: details.contractDoc || null,
    //     createdAt: details.createdAt || new Date().toISOString(),
    //     updatedAt: details.updatedAt || new Date().toISOString(),
    //     deletedAt: details.deletedAt || null,
    //   };

    //   if (state.data) {
    //     state.data.outSources.unshift(newOutSource);
    //     state.data.total += 1;

    //     // Keep only 10 in list
    //     if (state.data.outSources.length > 10) {
    //       state.data.outSources.pop();
    //     }
    //   } else {
    //     state.data = {
    //       outSources: [newOutSource],
    //       total: 1,
    //       page: 1,
    //       totalPages: 1,
    //     };
    //   }
    // },
    addOutSource(state, action: PayloadAction<any>) {
  const details = action.payload;
  if (!details) return;

  const newOutSource: OutSource = {
    id: details.id,
    companyName: details.companyName || "",
    contactPersonName: details.contactPersonName || "",
    mobileNo: details.mobileNo || "",
    email: details.email || "",
    warehouseId: details.warehouseId || "",
    cityId: details.cityId || "",
    address: details.address || "",
    specialization: details.specialization || "",
    billingCycle: details.billingCycle || "",
    serviceAreaCoverage: details.serviceAreaCoverage || "",
    contractStartDate: details.contractStartDate || "",
    contractEndDate: details.contractEndDate || "",
    vatNumber: details.vatNumber || "",
    crNumber: details.crNumber || "",
    primaryContactName: details.primaryContactName || "",
    primaryContactNumber: details.primaryContactNumber || "",
    primaryEmailAddress: details.primaryEmailAddress || "",
    active: details.active ?? false,
    userId: details.userId || "",
    vatDoc: details.vatDoc || null,
    crDoc: details.crDoc || null,
    companyLogo: details.companyLogo || null,
    contractDoc: details.contractDoc || null,
    createdAt: details.createdAt || new Date().toISOString(),
    updatedAt: details.updatedAt || new Date().toISOString(),
    deletedAt: details.deletedAt || null,
  };

  const incomingId = newOutSource.id ? String(newOutSource.id) : "";

  if (!state.data) {
    state.data = {
      outSources: [newOutSource],
      total: 1,
      page: 1,
      totalPages: 1,
    };
    return;
  }
  // Find by id
  const idx = state.data.outSources.findIndex((s) => String(s.id) === incomingId);

  if (idx === -1) {
    // insert new item at start and increment total
    state?.data?.outSources?.unshift(newOutSource);
    state.data.total = (state.data.total || 0) + 1;

    // keep list
    if (state.data.outSources.length > 10) {
      state.data.outSources.pop();
    }
  } else {
    state.data.outSources[idx] = {
      ...state.data.outSources[idx],
      ...newOutSource,
    };
  }
},


    // Update outSource by id
    outSourceUpdate(state, action: PayloadAction<OutSourceUpdatePayload>) {
      const { id, ...updates } = action.payload;
      if (!id || !state.data?.outSources) return;

      const outSource = state.data.outSources.find((p) => p.id === id);
      if (outSource) {
        Object.assign(outSource, updates);
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

// ✅ Export actions
export const {
  setOutSourceList,
  addOutSource,
  outSourceUpdate,
  setLoading,
  setError,
} = outSourceSlice.actions;

// ✅ Export reducer
export default outSourceSlice.reducer;
